import { defineStore } from "pinia";

export const useResponsiveStore = defineStore("responsiveStore", () => {
  const isDesktop = ref(false);
  return {
    isDesktop,
  };
});
